import React, { useEffect, useState } from 'react';
import { LogoSE, LogoNO, LogoFI, LogoDK, LogoEN, LogoIS } from '../Svg/Svg';

const languages = [
    {
        languageCode: 'sv',
        logo: <LogoSE />,
        title: 'SV',
    },
    {
        languageCode: 'no',
        logo: <LogoNO />,
        title: 'NO',
    },
    {
        languageCode: 'fi',
        logo: <LogoFI />,
        title: 'FI',
    },
    {
        languageCode: 'da',
        logo: <LogoDK />,
        title: 'DA',
    },
    {
        languageCode: 'en',
        logo: <LogoEN />,
        title: 'EN',
    },
    {
        languageCode: 'is',
        logo: <LogoIS />,
        title: 'IS',
    },
];

const countries = [
    {
        languageCode: 'se',
        logo: <LogoSE />,
        title: 'SE',
    },
    {
        languageCode: 'no',
        logo: <LogoNO />,
        title: 'NO',
    },
    {
        languageCode: 'fi',
        logo: <LogoFI />,
        title: 'FI',
    },
    {
        languageCode: 'dk',
        logo: <LogoDK />,
        title: 'DK',
    },
    {
        languageCode: 'is',
        logo: <LogoIS />,
        title: 'IS',
    },
];

export default function MultinationalTabs({
    children,
    codeType = 'languages',
    excludedCodes = [],
    renderWithFlag = null,
}) {
    const currentCodes = codeType === 'languages' ? languages : countries;

    const [activeTab, setActiveTab] = useState(currentCodes[0]?.languageCode);

    useEffect(() => {
        if (!!excludedCodes.length) {
            const firstTab = currentCodes?.filter(
                (code) => !excludedCodes.includes(code.languageCode),
            )[0]?.languageCode;
            
            setActiveTab(firstTab);
        }
    }, [excludedCodes, currentCodes, setActiveTab]);

    const onSetActiveTab = (e) => {
        setActiveTab(e.currentTarget.id);
    };

    const childrenWithProps = React.Children.map(children, (child) => {
        return React.cloneElement(child, {
            flag: activeTab,
        });
    });

    return (
        <>
            <div className="navigation-tabs__bottom-indent-wrapper--16">
                <ul className="navigation-tabs__list">
                    {currentCodes?.map(
                        (code) =>
                            !excludedCodes.includes(code.languageCode) && (
                                <li
                                    className="navigation-tabs__list-item--multinational"
                                    key={code.languageCode}
                                >
                                    <span
                                        id={code.languageCode}
                                        className={
                                            activeTab === code.languageCode
                                                ? 'navigation-tabs__link navigation-tabs__link--active navigation-tabs__with-logo'
                                                : 'navigation-tabs__link navigation-tabs__with-logo'
                                        }
                                        onClick={onSetActiveTab}
                                    >
                                        {code.logo}
                                        <span>{code.title}</span>
                                    </span>
                                </li>
                            ),
                    )}
                </ul>
            </div>
            <div>
                {renderWithFlag ? renderWithFlag(activeTab) : childrenWithProps}
            </div>
        </>
    );
}
